import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import io from "socket.io-client";
import "./layout.css";
import autoAnimate from "@formkit/auto-animate";
import { socketNotification } from "../CommonPageHeader/redux/notificationSlice";
import { getAllNotifications } from "../CommonPageHeader/redux/thunk";
import { successFunction } from "../Alert/Alert";

const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const parent = useRef(null);
  const userId = useSelector((state) => state.auth.userId);

  useEffect(() => {
    parent.current && autoAnimate(parent.current);
  }, [parent]);

  useEffect(() => {
    let socket; // Declare socket here
    if (userId) {
      const socketUrl = process.env.REACT_APP_SOCKET_URL;
      // Initialize Socket.IO client
      socket = io(socketUrl, {
        query: { userId },
        withCredentials: true,
      });

      // Listen for notifications
      socket.on("notification", (data) => {
        dispatch(socketNotification(data.message));
        successFunction(`${data.message}`);
        dispatch(getAllNotifications());
      });
    }

    // Clean up socket connection on component unmount
    return () => {
      if (socket) {
        socket.disconnect();
      }
    };
  }, [userId, dispatch]);

  const collapsed = useSelector((state) => state.layout.collapsed);

  return (
    <>
      <div id="layout-wrapper" className="d-flex">
        <div className={`${collapsed ? "main-content collapsed" : "main-content"}`}>
          <div className="page-content">
            <div className="container-fluid p-0">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
